<template>
  <li class="dx-list-item">
    <slot></slot>
  </li>
</template>
<script>
export default {
  name: 'dx-list-item',
};
</script>
<style scoped lang="scss">
.dx-list-item {
  color: var(--dx-color--grey-dark-light)
}
</style>
